<template>
  <div
    class="edit-wave-player"
    :class="{
      [`edit-wave-player--${createRenderType}`]: true,
    }"
  >
    <div class="edit-wave-player-select-area-box flex">
      <div class="edit-wave-player-select-area-time width-0 flex1">
        {{
          `${renderData.startTime} / ${mediaUtil.formatTime(
            renderData.duration
          )}`
        }}
      </div>
      <div class="edit-wave-player-select-close" v-if="!props.hideRemove">
        <IconButton
          size="32px"
          icoSize="20px"
          @onClick="onRemoveClick"
          backgroundColor="rgba(255, 255, 255, 0.1)"
          hoverBackgroundColor="rgba(255, 255, 255, 0.2)"
        >
          <img src="@/assets/img/editor/delete-remove-ico.png" />
        </IconButton>
      </div>
    </div>
    <div class="edit-wave-player-select-area-edit-box">
      <AudioWavePlayer
        ref="refAudioWavePlayer"
        :onlyRenderMode="props.onlyRenderMode"
        :autoToStartIfNotCurrent="props.autoToStartIfNotCurrent"
        :canSeekNotCurrent="props.canSeekNotCurrent"
        :dragSeek="props.dragSeek"
        :url="props.url"
        :duration="props.duration"
        :waveformData="props.waveformData"
        @changeProgress="onChangeProgress"
        @togglePlay="doTogglePlay"
        :isPlay="renderData.isplay"
        :progress="renderData.progress"
        @syncDuration="syncDuration"
        @syncPlayState="syncPlayState"
        @syncLoadingState="syncLoadingState"
        @syncProgress="syncProgress"
        :formatTimeByProgress="formatTimeByProgress"
        :renderStyle="
          createRenderType == 'mobile'
            ? {
                '--progressTimeTop': '-55px',
                '--height': '88px',
                '--opAreaBackground': 'rgba(148, 173, 255, 0.3)',
                '--waveBackground': 'rgba(148, 173, 255, 0.6)',
                '--waveCanvasHeight': '30px',
                '--waveBoxPadding': '29px 0 29px 0',
                '--opProgressCircleColor': 'rgba(255,255,255,0.75)',
                '--opProgressCircleColor': '#94ADFF',
                '--opIcoSize': '16px',
                '--opAreaWidth': '64px',
                '--opAreaBorderRight': 'null',

                '--progressColor': 'rgba(255, 255, 255, 1)',
                '--progressHoverColor': 'rgba(255, 255, 255, 0.5)',
                '--progressTrasform': 'scale(1, 2.93)',
              }
            : {
                '--progressTimeTop': '-70px',
                '--height': '88px',
                '--opAreaBackground': 'rgba(148, 173, 255, 0.3)',
                '--waveBackground': 'rgba(148, 173, 255, 0.6)',
                '--waveCanvasHeight': '30px',
                '--waveBoxPadding': '29px 0 29px 0',

                '--opProgressCircleColor': 'rgba(255,255,255,0.75)',
                '--opProgressCircleColor': '#94ADFF',
                '--opAreaWidth': '88px',
                '--opIcoSize': '24px',
                '--opAreaBorderRight': 'null',

                '--progressColor': 'rgba(255, 255, 255, 1)',
                '--progressHoverColor': 'rgba(255, 255, 255, 0.5)',
                '--progressTrasform': 'scale(1, 2.93)',
              }
        "
      ></AudioWavePlayer>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import IconButton from "@/components/basic/button/IconButton.vue";

import AudioWavePlayer from "@/components/media/audioPlayer/AudioWavePlayer.vue";
import mediaUtil from "@/components/media/utils/utils.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const Router = useRouter();
const route = useRoute();

const props = defineProps({
  hideRemove: {
    type: Boolean,
    default: false,
  },
  url: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 0,
  },
  waveformData: {
    type: Object,
    default: null,
  },
  onlyRenderMode: {
    // 此模式url 播放无效仅仅用来渲染
    type: Boolean,
    default: false,
  },
  progress: {
    type: Number,
    default: 0,
  },
  isplay: {
    type: Boolean,
    default: false,
  },
  dragSeek: {
    type: Boolean,
    default: true,
  },
  autoToStartIfNotCurrent: {
    type: Boolean,
    default: true,
  },
  canSeekNotCurrent: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits([
  "changeProgress",
  "syncDuration",
  "syncPlayState",
  "syncLoadingState",
  "syncProgress",
  "remove",
  "togglePlay",
  "changeProgress",
]);

const refAudioWavePlayer = ref(null);

const renderData = reactive({
  duration: 0,
  progress: 0,
  startTime: "00:00",
  isplay: false,
  buffer: false,
});

const formatTimeByProgress = (progress) => {
  return mediaUtil.formatTime(progress * renderData.duration);
};

const syncDuration = (duration) => {
  renderData.duration = duration;
  emits("syncDuration", duration);
};

const syncPlayState = (playState) => {
  renderData.isplay = playState;
  emits("syncPlayState", playState);
};
const syncLoadingState = (loadingState) => {
  renderData.buffer = loadingState;
  emits("syncLoadingState", loadingState);
};
const syncProgress = (progress, startTime, currentTime) => {
  renderData.progress = progress;
  renderData.startTime = startTime;
  emits("syncProgress", progress, startTime, currentTime);
};

const onChangeProgress = (progress) => {
  emits("changeProgress", progress);
};

const doTogglePlay = (isPlay) => {
  emits("togglePlay", isPlay);
};

const onRemoveClick = () => {
  emits("remove");
};

watch(
  () => {
    return props.duration;
  },
  () => {
    renderData.duration = props.duration;
  }
);

watch(
  () => {
    return props.isplay;
  },
  () => {
    renderData.isplay = props.isplay;
  }
);

watch(
  () => {
    return props.progress;
  },
  () => {
    renderData.progress = props.progress;
    renderData.currentTime = (props.progress / 100) * renderData.duration;
    renderData.startTime = mediaUtil.formatTime(renderData.currentTime);
  }
);

onMounted(() => {
  renderData.duration = props.duration;
});

onUnmounted(() => {});

defineExpose({
  changeProgress: (progress) => {
    refAudioWavePlayer.value?.changeProgress(progress);
  },
  changeOp: (isPlay) => {
    refAudioWavePlayer.value?.changeOp(isPlay);
  },
});

watch(
  () => {
    return props.duration;
  },
  () => {
    renderData.duration = props.duration;
  }
);
</script>
<style lang="scss">
.edit-wave-player {
  padding: 11px 0 8px;

  .edit-wave-player-select-area-box {
    display: flex;
    align-items: center;
    padding: 0 6px 0 14px;
  }
  .edit-wave-player-select-area-time {
    font-size: 14px;
    font-weight: normal;
    line-height: 36px;
    color: #ffffff;
    // padding: 6px 0 0 0;
  }
  .edit-wave-player-select-area-edit-box {
    margin: 12px 0 0 0;
  }
  .edit-wave-player-select-close {
    padding: 0 6px 0 0;
  }
  &.edit-wave-player--mobile {
    padding: 9px 0 12px 0;
    .edit-wave-player-select-area-box {
      padding: 0 6px 0 14px;
      .edit-wave-player-select-area-box {
        padding: 0;
      }
      .edit-wave-player-select-close {
        // padding: 4px 0 0 0;
      }
    }
    .edit-wave-player-select-area-edit-box {
      margin: 8px 0 0 0;
      .clipping-select-duration-edit {
        padding: 6px 0 0 0;
      }
    }
    .edit-wave-player-select-area-time {
      padding: 0;
    }
    .edit-wave-player-select-close {
      padding: 0 6px 0 0;
    }
  }
}
</style>
